import { Component, OnInit } from "@angular/core";

interface IBandeira {
  icon: string;
  maxWidth?: string;
}
@Component({
  selector: "app-bandeiras",
  templateUrl: "./bandeiras.component.html",
  styleUrls: ["./bandeiras.component.scss"],
})
export class BandeirasComponent implements OnInit {
  texto: any;
  setaBaixo: any;
  constructor() {}

  bandeiras: IBandeira[] = [
    { icon: "assets/img/bandeiras/logo12.png" },
    { icon: "assets/img/bandeiras/logo19.png" },
    { icon: "assets/img/bandeiras/logo31.png" },
    { icon: "assets/img/bandeiras/logo14.png" },
    { icon: "assets/img/bandeiras/logo2.png" },
    { icon: "assets/img/bandeiras/logo18.png" },
    { icon: "assets/img/bandeiras/logo1.png" },
    { icon: "assets/img/bandeiras/logo24.png" },
    { icon: "assets/img/bandeiras/logo25.png" },
    { icon: "assets/img/bandeiras/logo26.png" },
    { icon: "assets/img/bandeiras/logo3.png" },
    { icon: "assets/img/bandeiras/logo4.png" },
    { icon: "assets/img/bandeiras/logo5.png" },
    { icon: "assets/img/bandeiras/logo6.png" },
    { icon: "assets/img/bandeiras/logo7.png" },
    { icon: "assets/img/bandeiras/logo8.png" },
    { icon: "assets/img/bandeiras/logo9.png" },
    { icon: "assets/img/bandeiras/logo10.png" },
    { icon: "assets/img/bandeiras/logo11.svg" },
    { icon: "assets/img/bandeiras/logo15.png" },
    { icon: "assets/img/bandeiras/logo13.png" },
    { icon: "assets/img/bandeiras/logo16.png" },
    { icon: "assets/img/bandeiras/logo17.png" },
    { icon: "assets/img/bandeiras/logo-romcard.png" },
    { icon: "assets/img/bandeiras/logo20.png" },
    { icon: "assets/img/bandeiras/logo21.png" },
    { icon: "assets/img/bandeiras/logo22.png" },
    { icon: "assets/img/bandeiras/logo23.png" },
    { icon: "assets/img/bandeiras/logo27.png" },
    { icon: "assets/img/bandeiras/logo28.png", maxWidth: "70px" },
    { icon: "assets/img/bandeiras/logo29.png" },
    { icon: "assets/img/bandeiras/logo30.png" },
    { icon: "assets/img/bandeiras/logo32.svg" },
    { icon: "assets/img/bandeiras/nutricash.svg" },
    { icon: "assets/img/bandeiras/mult-vale.png" },
    { icon: "assets/img/bandeiras/logo-yucard.svg" },
    { icon: "assets/img/bandeiras/integra.png" },
    { icon: "assets/img/bandeiras/o2.webp" },
  ];

  ngOnInit(): void {
    this.texto = document.querySelector("#texto");
    this.setaBaixo = document.querySelector("#seta-baixo");
  }
  mostraMais() {
    const ctBandeiras = document.querySelector("#ct-bandeiras");
    ctBandeiras?.classList.toggle("active");

    if (ctBandeiras?.classList.contains("active")) {
      this.texto.textContent = "Mostrar menos";
      this.setaBaixo.src = "assets/img/setaCima.png";
    } else {
      this.texto.textContent = "Consulte todas as bandeiras";
      this.setaBaixo.src = "assets/img/seta-bottom.png";
    }
  }
}
